import { NgModule } from '@angular/core';
import { MainCategoriesMenuDataAccessModule } from '@main/categories-menu/data-access';
import { CustomHamburgerMenuService, MainCategoriesMenuFeatureModule } from '@main/categories-menu/feature';
import { MainInfoblockDataAccessModule } from '@main/infoblock/data-access';
import { MainInfoblockFeatureModule } from '@main/infoblock/feature';
import { MainInfoblockUtilsModule } from '@main/infoblock/utils';
import { MainMobileMenuDataAccessModule } from '@main/mobile-menu/data-access';
import { MainMobileMenuFeatureModule } from '@main/mobile-menu/feature';
import { CustomBreadcrumLazybModule, FooterNavigationModule, SitemapModule } from '@main/navigation/ui';
import { MainPhoneDataAccessModule } from '@main/phone/data-access';
import { MainPhoneFeatureModule } from '@main/phone/feature';
import { SmartBannerDataAccessModule } from '@main/smart-banner/data-access';
import { MainSnackbarDataAccessModule } from '@main/snackbar/data-access';
import { MainSnackbarFeatureModule } from '@main/snackbar/feature';
import { CategoriesMenuModule, CustomHamburgerMenuModule } from '@sdvor/main/categories-menu/ui';
import { MobileMenuModule } from '@sdvor/main/mobile-menu/ui';
import { GlobalMessageComponentModule, HamburgerMenuService } from '@spartacus/storefront';

@NgModule({
  providers: [{ provide: HamburgerMenuService, useExisting: CustomHamburgerMenuService }],
  imports: [
    GlobalMessageComponentModule,
    MobileMenuModule,
    CategoriesMenuModule,
    MainSnackbarFeatureModule,
    MainCategoriesMenuFeatureModule,
    MainSnackbarDataAccessModule,
    MainInfoblockDataAccessModule,
    MainInfoblockFeatureModule,
    MainInfoblockUtilsModule,
    MainMobileMenuDataAccessModule.forRoot(),
    MainMobileMenuFeatureModule,
    MainCategoriesMenuDataAccessModule.forRoot(),
    MainPhoneDataAccessModule.forRoot(),
    MainPhoneFeatureModule,
    FooterNavigationModule,
    SitemapModule,
    CustomBreadcrumLazybModule,
    CustomHamburgerMenuModule,
    SmartBannerDataAccessModule,
  ],
})
export class MainShellModule {}
